exports.LoginPageView = require('./LoginPageView').default;
exports.BugReportView = require('./BugReportView').default;
exports.ProfilePageView = require('./ProfilePageView').default;
